import { actionTypes as ACTION, mutationTypes as MUTATION } from './types';
import { ProductPickerServices } from '../services/ProductPickerServices';
import { uniqueArrayOfObjects, saveList } from '../utils/helper';

const actions = {
  [ACTION.FETCH_PRODUCTS]({ state, commit }: any, params: { query: string; page_id: number; changeQuery: boolean }) {
    return new Promise(async (resolve, reject) => {
      try {
        const { list, queryList, cachedQueryList, endCursor, endCursorQuery } = state;
        const { query, changeQuery } = params;

        const isQuery = query.length !== 0;

        const res = await ProductPickerServices.getAllProducts({
          s: query,
          nextCursor: isQuery ? endCursorQuery : endCursor,
          assignedOnly: false,
        });

        const { products, pageInfo } = res;
        const uniqueListProducts = uniqueArrayOfObjects(products);
        const isFetchedAll = !pageInfo?.hasNextPage;

        if (isQuery) {
          if (isFetchedAll) commit(MUTATION.SET_FETCHED_ALL_QUERY);
          state.endCursorQuery = (pageInfo?.hasNextPage && pageInfo?.endCursor) || '';
          changeQuery
            ? (state.queryList = uniqueListProducts)
            : saveList({ data: uniqueListProducts, list: queryList }),
            saveList({ data: uniqueListProducts, list: cachedQueryList });
        } else {
          if (isFetchedAll) commit(MUTATION.SET_FETCHED_ALL);
          state.endCursor = pageInfo?.endCursor;
          saveList({ data: uniqueListProducts, list: list });
          saveList({ data: uniqueListProducts, list: cachedQueryList });
        }

        resolve(res.data);
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },
};
export default actions;
